import React from 'react';
import PropTypes from 'prop-types';

function VirtualCardIcon({ width, height, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 34 24"
      className={className}
    >
      <defs>
        <linearGradient id="prefix__c" x1="151.991%" x2="-42.073%" y1="-52.809%" y2="146.177%">
          <stop offset="0%" stopColor="#D243FF" />
          <stop offset="100%" stopColor="#F77100" />
        </linearGradient>
        <linearGradient id="prefix__e" x1="111.493%" x2="-14.958%" y1="-6.689%" y2="109.837%">
          <stop offset="0%" stopColor="#FFF243" />
          <stop offset="100%" stopColor="#F7D100" />
        </linearGradient>
        <rect id="prefix__a" width={34} height={24} x={0} y={0} rx={3} />
        <path
          id="prefix__d"
          d="M38.825 36.177c.45.267.719.759.7 1.282a1.422 1.422 0 01-1.432 1.43 1.42 1.42 0 01-1.013-.417 1.42 1.42 0 01-.417-1.013 1.433 1.433 0 012.162-1.282zM18.274 24.252c2.657 0 3.714 1.287 3.714 4.291 0 1.8-.372 3.086-1.696 3.8l2.175 6.46H20.07l-1.9-5.967h-1.288v5.968h-2.287V24.252h3.678zm13.411 0c2.637 0 3.74 1.369 3.74 4.414 0 2.943-.98 4.456-3.74 4.456h-1.368v5.682h-2.29V24.252h3.658zm-18.367 0v2.065h-2.452v12.485H8.578V26.317H6.146v-2.065h7.172zm12.83 0v14.55h-2.287v-14.55h2.288zm13.03.006V34.72H37.01V24.258h2.166zm-7.452 2.057v.002h-1.409v4.74h1.41c1.225 0 1.409-1.082 1.409-2.37 0-1.29-.186-2.372-1.41-2.372zm-13.433.002h-1.41v4.456h1.41c1.225 0 1.409-1.021 1.409-2.228 0-1.207-.186-2.228-1.41-2.228zM37.31 14.2c.562 0 1.097.233 1.48.643.533.602.556 1.62.557 2.982v.277c0 1.5.011 2.616-.557 3.258a2.02 2.02 0 01-2.96 0c-.497-.562-.55-1.487-.556-2.714v-1.089c.006-1.227.06-2.152.557-2.714.382-.41.918-.643 1.48-.643zm-27.83.643c.532.604.556 1.62.556 2.982v.277c0 1.5.012 2.616-.557 3.258a1.824 1.824 0 01-1.485.643 1.818 1.818 0 01-1.485-.643c-.498-.562-.551-1.487-.557-2.714v-1.089c.006-1.227.06-2.152.557-2.714a1.82 1.82 0 011.485-.642 1.82 1.82 0 011.485.642zm2.81-.559l1.79 4.534v-4.534h1.202v7.633H14.22l-1.801-4.534v4.534h-1.202v-7.633h1.074zm7.493 0v1.083h-2.008v2.165h1.73v1.084h-1.73v2.219h2.008v1.082h-3.209v-7.633h3.209zm6.615 0v1.083h-1.287v6.55h-1.2v-6.55h-1.276v-1.083h3.763zm2.011 0l.75 5.79 1.051-5.79h1.33l1.062 5.79.739-5.79h1.318l-1.435 7.633h-1.256l-1.093-5.8-1.083 5.8h-1.255l-1.446-7.633h1.318zM7.427 15.572c-.21.348-.261 1.042-.267 2.276v.255c0 1.394.048 2.165.267 2.528a.615.615 0 00.47.29h.098a.634.634 0 00.58-.29c.224-.37.257-1.136.257-2.53 0-1.395-.031-2.165-.258-2.531l.006.002a.633.633 0 00-.58-.29.614.614 0 00-.573.29zm29.894-.29a.613.613 0 00-.568.29c-.225.371-.268 1.136-.268 2.53 0 1.395.043 2.166.268 2.531a.612.612 0 00.47.288h.098a.632.632 0 00.579-.29c.21-.348.253-1.042.258-2.276V18.1c0-1.395-.031-2.165-.258-2.531l-.01.002a.63.63 0 00-.57-.29zM22.298 6.01a6.697 6.697 0 016.688 4.508l.745-.192-.69 2.46-1.786-1.82.748-.194a5.683 5.683 0 00-10.947.931.507.507 0 01-.997-.176 6.697 6.697 0 016.239-5.517z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="prefix__b" fill="#fff">
          <use xlinkHref="#prefix__a" />
        </mask>
        <use fill="#111" xlinkHref="#prefix__a" />
        <g fillRule="nonzero" mask="url(#prefix__b)">
          <g transform="rotate(27 31.967 4.81)">
            <use fill="url(#prefix__c)" xlinkHref="#prefix__d" />
            <use fill="url(#prefix__e)" fillOpacity={0.9} xlinkHref="#prefix__d" />
          </g>
        </g>
      </g>
    </svg>
  );
}

VirtualCardIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

VirtualCardIcon.defaultProps = {
  width: 34,
  height: 24,
};

export default VirtualCardIcon;
